import { Login } from '../pages';

export default [
  {
    path: '*',
    Component: Login,
  },
];
